import React from 'react'
import { BottomSeparator } from './style'
import CommentItem from 'flow/siteProposal/components/comments/commentItem'

const CommentsList = ({commentData, getCommentsData}) => {
  const sortData = commentData.sort((a,b) => (Date.parse(a.updatedAt) < Date.parse(b.updatedAt) ? 1 : ((Date.parse(b.updatedAt) < Date.parse(a.updatedAt)) ? -1 : 0)))
  const commentsList = sortData.map((comment) => {
    const profile = {
      id: comment.UserId,
      firstName: comment.User.firstName,
      lastName: comment.User.lastName,
      roleId: comment.User.Role.id,
      organisation: comment.User.Role.name,
      Role: {
        name: comment.User.Role.name
      },
      commentCategory: comment.CommentCategory.name
    }

    return (
      <React.Fragment key={comment.id}>
        <BottomSeparator><hr/></BottomSeparator>
        <CommentItem
          commentId={comment.id}
          text={comment.content}
          profile={profile}
          countReplies={comment.Replies.length}
          createdAt={comment.createdAt}
          updatedAt={comment.updatedAt}
          getCommentsData={getCommentsData}
          isResolved={comment.isResolved}
        />
      </React.Fragment>
    )
  }
  )
  
  return (
    <section>
      {commentsList}
    </section>
  )
}

export default CommentsList